
import { defineComponent, computed, toRefs, PropType } from "vue";
import "./typography.scss";
import { colorTokens, typographyTokens } from "../enums";

export default defineComponent({
  name: "adm-typography",
  inheritAttrs: false,
  props: {
    variant: {
      type: String as PropType<typographyTokens>,
      default: "body1",
    },
    tag: {
      type: String,
      default: null,
    },
    gutterBottom: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String as PropType<colorTokens>,
      default: "text",
    },
  },
  setup(props) {
    const { color, gutterBottom, tag, variant } = toRefs(props);

    const classes = computed(() => [
      "adm-typography",
      `adm-typography-${variant.value}`,
      `adm-color--${color.value}`,
      {
        "adm-typography--gutter-bottom": gutterBottom.value,
      },
    ]);

    const tagName = computed(() => {
      if (tag.value) {
        return tag.value;
      }

      if (["body1", "body2"].indexOf(variant.value) !== -1) {
        return "p";
      }

      if (["h1", "h2", "h3", "h4", "h5", "h6"].indexOf(variant.value) !== -1) {
        return variant.value;
      }

      // Why div? There must be span
      return "div";
    });

    return {
      classes,
      tagName,
    };
  },
});
